<app-auth-header></app-auth-header>
<div class="bg-reset">
  <div class="container">
    <div class="row popeye">
      <div class="col-md-5 tax-payee">
        <h6 class="mt-4 mb-4" style="text-align: center">Reset Password</h6>
        <form [formGroup]="resetPassForm" (submit)="resetPassword()">
        <div class="form-group app-center mb-4">
          <label>
            <small>Email</small>
            <input class="form-control" type="email" formControlName="email" [value]="email" readonly />
          </label>
        </div>
        <div class="form-group app-center mb-2">
          <label>
            <small>New Password</small>
            <input 
              class="form-control" 
              type="password" 
              formControlName="password" 
              id="password"
              placeholder="Enter a new password here"
              [ngClass]="{ 'is-invalid': resetPassForm.controls.password.invalid && resetPassForm.controls.password.touched && resetPassForm.controls.password.errors?.required, 'form-control': true }"
            />
          </label>
        </div>

        <div class="password-toggle d-flex justify-content-start mb-4">
          <label>
              <div class="form-check form-switch mb-2">
                  <input type="checkbox" id="togglePassword" formControlName="togglePassword" [value]="showPassword" (change)="togglePassword()" class="form-check-input me-2">
                  <label class="form-check-label me-5">Show Password</label>
              </div>
          </label>
      </div>

        <div class="app-center mb-4">
          <button class="btn btn-block btn-warning">
            Reset Password
          </button>
        </div>
      </form>
      </div>
    </div>

  </div>
</div>
<!--<app-footer></app-footer>-->